import { getTransferExecutePath } from "util/v3UxConfig";

const getTransferPath = (type = "internal") => getTransferExecutePath(type);

export const itemIsClickeable = () => true;

export function resolveTransferFormGoBackPath({ internalTransfer, transferGroup }) {
    if (transferGroup === "toContact") {
        return getTransferPath("toContact");
    }
    return getTransferPath(internalTransfer ? "internal" : "thirdParties");
}

export function resolveTransferFormResetGoBackPath({ internalTransfer, transferGroup }) {
    return `${resolveTransferFormGoBackPath({ internalTransfer, transferGroup })}/back`;
}

export { getTransferPath as default, getTransferExecutePath };
